import { useEffect } from 'react';

/**
 * Reload / close-tab / URL-bar guard. These leave the document, so useBlocker never sees them
 * and the native "Leave site?" dialog is the only prompt the platform allows. Arm only while
 * dirty (`when`), or every reload of a clean page asks for confirmation.
 */
export function useUnloadGuard(when) {
  useEffect(() => {
    if (!when) return undefined;

    const onBeforeUnload = (event) => {
      event.preventDefault();
      // Chromium and WebKit still gate the dialog on the legacy `returnValue`.
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);

    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [when]);
}
